import { render, staticRenderFns } from "./LogsDetail.vue?vue&type=template&id=e6a478c4&scoped=true&"
import script from "./LogsDetail.vue?vue&type=script&lang=js&"
export * from "./LogsDetail.vue?vue&type=script&lang=js&"
import style0 from "./LogsDetail.vue?vue&type=style&index=0&id=e6a478c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a478c4",
  null
  
)

export default component.exports